import Ajv from 'ajv';

const ajv = new Ajv();

export const schema = {
  type: 'object',
  properties: {
    topic: {
      type: 'string',
      pattern: 'to/classroom/(.+)/register', // ssid, not classroom code
    },
    payload: {
      type: 'object',
      properties: {
        mac_broadcast: { type: 'string' },
      },
      required: ['mac_broadcast'],
    },
  },
  required: ['topic', 'payload'],
  additionalProperties: true,
};

const schemaCheck = ajv.compile(schema);

export const validator = schemaCheck;
